<form [formGroup]="form()">
  <div class="apm-card-content d-flex flex-column">
    <div class="row mb-4">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444830' | apmTranslate }}"></apm-section-title>
        <apm-select
          [useResourceTemplate]="true"
          [searchable]="true"
          [clearable]="true"
          [multiple]="true"
          [items]="classes$ | async"
          [colorFn]="classColor"
          bindLabel="value"
          formControlName="classes"
        ></apm-select>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444831' | apmTranslate }}"></apm-section-title>
        <apm-select
          [items]="subClasses$ | async"
          [searchable]="true"
          [clearable]="true"
          [multiple]="true"
          [useResourceTemplate]="true"
          bindLabel="value"
          formControlName="subClasses"
        >
        </apm-select>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444832' | apmTranslate }}"></apm-section-title>
        <apm-autocomplete
          [searchFn]="subFamiliesSearchFn"
          [multiple]="true"
          [clearable]="true"
          [comparatorFn]="subFamiliesCompareFunction"
          bindLabel="value"
          formControlName="subFamilies"
        >
        </apm-autocomplete>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <apm-section-title icon="t_assign" title="{{ '444833' | apmTranslate }}"></apm-section-title>
        <apm-autocomplete
          [searchFn]="modelsSearchFn"
          [multiple]="true"
          [clearable]="true"
          [virtualScroll]="true"
          [comparatorFn]="modelsCompareFunction"
          bindLabel="value"
          formControlName="models"
        >
        </apm-autocomplete>
      </div>
    </div>
  </div>
</form>
